import BoilerplatePopup from '../../../_verstappenshop/js/BoilerplatePopup'
import ShoppingcartPopupProduct from '../shoppingcart-popup-product'
import BlockFactory from 'webiq.boilerplate/scripts/support/BlockFactory'

export default class ShoppingcartPopup extends BoilerplatePopup {
	static title = 'shoppingcart-popup'

	init() {
		super.init()

		this.shoppingcartContent = this.getElement('content')
		this.shoppingcartCount = this.getElement('product-count')
		this.shoppingcartTotal = this.getElement('total')

		this.shoppingcartSubtotal = this.getElement('subtotal')
		this.shoppingcartPromotion = this.getElement('promotion')
		this.shoppingcartTotalExcl = this.getElement('total--excl')
		this.shoppingcartTax = this.getElement('total--tax')

		this.shoppingcartPopupMessage = this.getElement('message')

		this.closeButtons = this.element.querySelectorAll('[data-close]')
		this.closeButtons.forEach((closeButton) => {
			closeButton.addEventListener('click', () => this.close())

			closeButton.addEventListener('keydown', (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault()
					this.close()
				}
			})
		})

		window.eventEmitter.on('product:add', (payload) => {
			this.update(payload)
			this.toggle()
		})
		window.eventEmitter.on('overlay:close', () => this.hidePopup())
		window.eventEmitter.on('shoppingcart-popup-product:update', (payload) =>
			this.update(payload),
		)
		window.eventEmitter.on('shoppingcart-popup-button:toggle', () =>
			this.toggle(),
		)

		// this.bindProductEvents()
	}

	bindProductEvents() {
		this.element
			.querySelectorAll('.shoppingcart-popup-product')
			.forEach((element) => {
				BlockFactory.create(ShoppingcartPopupProduct, element, false)
			})
		this.element.querySelector('[tabindex="0"]').focus()
	}

	toggle() {
		if (this.hasModifier('active')) {
			this.close()
			return
		}

		this.open()
	}

	hidePopup() {
		this.addModifier('hidden')
		this.removeModifier('active')
	}

	update(payload) {
		if (this.shoppingcartCount) {
			this.shoppingcartCount.textContent = payload.count
		}

		if (this.shoppingcartContent) {
			this.shoppingcartContent.innerHTML = payload.html
		}

		if (this.shoppingcartSubtotal) {
			this.shoppingcartSubtotal.textContent = payload.producttotal
		}

		if (this.shoppingcartPromotion) {
			this.shoppingcartPromotion.textContent = `-${payload.promotion}`
		}

		if (this.shoppingcartTotal) {
			this.shoppingcartTotal.textContent = payload.total
		}

		if (this.shoppingcartTax) {
			this.shoppingcartTax.textContent = payload.tax
		}

		if (this.shoppingcartTotalExcl) {
			this.shoppingcartTotalExcl.textContent = payload.totalExcl
		}

		if (this.shoppingcartPopupMessage && payload.popupMessage) {
			this.shoppingcartPopupMessage.innerHTML = payload.popupMessage
		}

		window.eventEmitter.emit('shoppingcart-popup:update', payload)
		this.bindProductEvents()
	}

	open() {
		this.removeModifier('hidden')
		this.addModifier('active')
		this.eventEmitter.emit('popup:open')
		this.element.querySelector('[tabindex="0"]').focus()
	}

	close() {
		this.addModifier('hidden')
		this.removeModifier('active')
		this.eventEmitter.emit('popup:close')
		document.querySelector('.logo--header').focus()
	}
}
